import React, { useEffect } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
} from "@mui/material";
import {
  useFetchCoreActivitiesQuery,
} from "../../../services/roleReviewService"; // Ensure this is the correct import path
import useAuth from "../../../hooks/useAuth";
import { styled } from "@mui/system";
import { getColorByArea } from "../../../pages/report/component/DashboardCharts";
import { useLocation } from "react-router-dom";

const DataComp = ({ userId }) => {
  const { users } = useAuth();
  // const userId = users?.data?.user_id;
  const location = useLocation();
  const isJwtUser = location.state?.isJwtUser || false;
  const userIdFromState = location.state?.userId;
  let employeeId;

  if (isJwtUser) {
    employeeId = userIdFromState;
    console.log("isJwtUser", employeeId); // Use userId from state for JWT-based users
    // JWT users are treated as employees
  } else if (users?.role === "manager" || users?.role === "superadmin") {
    employeeId = userId; // Use the userId prop for managers and superadmins
    // Set role as manager
  } else {
    employeeId = users?.user_id;
    console.log("Normal", employeeId); // Use the logged-in user's ID for non-managers
    // Use the logged-in user's role
  }
  // let employeeId;
  // if (users?.role === "manager") {
  //   employeeId = userId; // Use the userId prop for managers
  // } else {
  //   employeeId = users?.user_id; // Use the logged-in user's ID for non-managers
  // }
  const {
    data: coreActivityData,
    error,
    isLoading,
    refetch: corefocus_details,
  } = useFetchCoreActivitiesQuery(employeeId);

  // console.log(coreActivityData?.data?.details); // Debugging log
  useEffect(() => {
    if (coreActivityData) {
      corefocus_details();
      console.log(coreActivityData.data); // Refetch data if employeeId is set
    }
  }, [coreActivityData, corefocus_details]);
  if (isLoading) return <Typography>Loading...</Typography>;
  if (error) return <Typography>Error: {error.message}</Typography>;

  // eslint-disable-next-line react-hooks/rules-of-hooks
  console.log("coreActivityData", coreActivityData);
  // Map the data to the required structure
  const coreFocusAreas =
    coreActivityData?.data?.details?.map((detail) => ({
      area: detail.core_focus_area,
      totalPercentage: detail.time_spent,
      color: getColorByArea(detail.core_focus_area), // Custom color
      subData:
        detail.critical_activity?.subtasks?.map((subtask) => ({
          subTask: subtask.area,
          timeSpent: subtask.importance || 0, // Default to 0 if undefined
          importance: subtask.importance || 0, // Default to 0
        })) || [],
    })) || [];

  return (
    <Box>
      {/* Layout the tables side-by-side */}
      <TableContainer sx={{ maxHeight: "auto" }}>
        <Table
          size="small"
          sx={{ border: "1px solid #f5f5f5", tableLayout: "fixed", width: "100%" }}
        >
          <colgroup>
            <col style={{ width: "10%" }} />
            <col style={{ width: "20%" }} />
            <col style={{ width: "45%" }} />
            <col style={{ width: "13%" }} />
            <col style={{ width: "12%" }} />
          </colgroup>
          <ReportCustomTableHead>
            <TableRow>
              <ReportCustomTableCell>
                Core Focus Area Totals
              </ReportCustomTableCell>
              <ReportCustomTableCell>Core Focus Area</ReportCustomTableCell>
              <ReportCustomTableCell>
                Critical Activities Within Each Focus Area
              </ReportCustomTableCell>
              <ReportCustomTableCell>Focus Area Time</ReportCustomTableCell>
              <ReportCustomTableCell>% of Total Time</ReportCustomTableCell>
            </TableRow>
          </ReportCustomTableHead>
          {coreFocusAreas.map((coreArea, index) => (
            <ReportCustomTableBody
              className="pdf-avoid-break"
              key={index}
            >
              {/* Core Focus Area Row */}
              <TableRow sx={{ background: "#fae1d4" }}>
                  <ReportCustomTableCellData>
                    {coreArea.totalPercentage}%
                  </ReportCustomTableCellData>
                  <ReportCustomTableCellData>
                    {coreArea.area}
                  </ReportCustomTableCellData>
                  <ReportCustomTableCellData></ReportCustomTableCellData>
                  <ReportCustomTableCellData></ReportCustomTableCellData>
                  <ReportCustomTableCellData></ReportCustomTableCellData>
                </TableRow>

                {/* Subtask Rows */}
                {coreArea.subData.map((subTask, subIndex) => {
                  const adjustedTimeSpent =
                    (subTask.timeSpent * coreArea.totalPercentage) / 100;
                  return (
                    <TableRow key={subIndex}>
                      <ReportCustomTableCellDataTwo></ReportCustomTableCellDataTwo>
                      <ReportCustomTableCellDataTwo></ReportCustomTableCellDataTwo>
                      <ReportCustomTableCellDataTwo>
                        {subTask.subTask}
                      </ReportCustomTableCellDataTwo>
                      <ReportCustomTableCellDataTwo>
                        {subTask.importance}%
                      </ReportCustomTableCellDataTwo>
                      <ReportCustomTableCellDataTwo>
                        {adjustedTimeSpent.toFixed(0)}%
                      </ReportCustomTableCellDataTwo>
                    </TableRow>
                  );
                })}

                {/* Total Row */}
                <TableRow>
                  <ReportCustomTableCellData></ReportCustomTableCellData>
                  <ReportCustomTableCellData></ReportCustomTableCellData>
                  <ReportCustomTableCellData></ReportCustomTableCellData>
                  <ReportCustomTableCellData>100%</ReportCustomTableCellData>
                  <ReportCustomTableCellData>
                    {coreArea.totalPercentage}%
                  </ReportCustomTableCellData>
              </TableRow>
            </ReportCustomTableBody>
          ))}
        </Table>
      </TableContainer>
    </Box>
  );
};

export default DataComp;

const tableCellWrapStyles = {
  wordWrap: "break-word",
  overflowWrap: "break-word",
  whiteSpace: "normal",
};

// Report Table
const ReportCustomTableHead = styled(TableHead)(() => ({
  background: "#1085AB",
}));
const ReportCustomTableCell = styled(TableCell)(() => ({
  fontSize: "16px",
  fontWeight: "600",
  lineHeight: "1.2",
  color: "#ffffff",
  padding: "15px 15px",
  border: "0",
  ...tableCellWrapStyles,
}));
const ReportCustomTableCellData = styled(TableCell)(() => ({
  fontSize: "16px",
  fontWeight: "700",
  lineHeight: "1.2",
  color: "#333333",
  padding: "15px 15px",
  border: "0",
  ...tableCellWrapStyles,
}));
const ReportCustomTableCellDataTwo = styled(TableCell)(() => ({
  fontSize: "16px",
  fontWeight: "400",
  lineHeight: "1.2",
  color: "#333333",
  padding: "5px 15px",
  border: "0",
  ...tableCellWrapStyles,
}));
const ReportCustomTableBody = styled(TableBody)(() => ({
  border: "0",
  background: "#ffffff",
}));
